import { Habit } from "@/types/habit";
import { Progress } from "@/components/ui/progress";

interface ProgressIndicatorProps {
  habits: Habit[];
}

export const ProgressIndicator = ({ habits }: ProgressIndicatorProps) => {
  const totalDaysAll = habits.reduce((acc, habit) => acc + habit.totalDays, 0);
  const completedDaysAll = habits.reduce(
    (acc, habit) => acc + habit.completedDays,
    0
  );
  const totalProgress = totalDaysAll > 0 ? (completedDaysAll / totalDaysAll) * 100 : 0;

  return (
    <div className="w-full mt-5" data-tour="progress-bar">
      <div className="flex items-center justify-between mb-2">
        <span className="text-base font-medium text-muted-foreground">Overall Progress</span>
        <span className="text-lg font-bold text-primary">
          {Math.round(totalProgress)}%
        </span>
      </div>
      <Progress value={totalProgress} className="h-4 w-full bg-white border border-border" />
    </div>
  );
};
